
import React, { useEffect, useState } from 'react';
import { useCartPromotions } from '../../cart/hooks/useCartPromotions';
import { Form } from 'react-bootstrap';

/**
 * @param {{
 *   product: any,
 *   onSelectPromotion: (promotion, quantity) => void
 * }} props
 */
export const ProductPromotions = ({ product, onSelectPromotion }) => {
    const { promotions, loading } = useCartPromotions(product.id);
    const [selectedPromoId, setSelectedPromoId] = useState(null);

    if (loading || !promotions || promotions.length === 0) return null;

    const handleSelection = (promo) => {
        setSelectedPromoId(promo.id);
        // If promo has min quantity, calculate new price and notify parent
        // For MVP, just notify parent to update quantity if needed
        if (onSelectPromotion) {
            onSelectPromotion(promo);
        }
    };

    const handleClear = () => {
        setSelectedPromoId(null);
        if (onSelectPromotion) onSelectPromotion(null);
    };

    return (
        <div className="product-promotions border p-3 rounded mb-3">
            <h6 className="text-primary mb-3">Ofertas exclusivas</h6>
            <Form>
                {promotions.map(promo => (
                    <div key={promo.id} className="d-flex align-items-center justify-content-between mb-2 p-2 border rounded"
                        style={{ backgroundColor: selectedPromoId === promo.id ? '#f8f9fa' : 'white' }}>
                        <Form.Check
                            type="radio"
                            id={`promo-${promo.id}`}
                            label={
                                <div>
                                    <span className="fw-bold">{promo.description}</span>
                                    <span className="ms-3 text-muted small">
                                        {promo.minQuantity ? `Cant. min. ${promo.minQuantity} Uds` : ''}
                                        {promo.discountPercentage ? ` - dto. ${promo.discountPercentage}%` : ''}
                                    </span>
                                </div>
                            }
                            name="product-promotions"
                            checked={selectedPromoId === promo.id}
                            onChange={() => handleSelection(promo)}
                        />
                        {/* Calculate and show price with discount if possible? 
                            We need base price. 
                            If we know the discount %, we can show "New Price per Unit".
                        */}
                    </div>
                ))}
                <div className="d-flex align-items-center mb-2 p-2">
                    <Form.Check
                        type="radio"
                        id="promo-none"
                        label="No quiero ninguna promoción"
                        name="product-promotions"
                        checked={selectedPromoId === null}
                        onChange={handleClear}
                    />
                </div>
            </Form>
        </div>
    );
};
